/* unplugin-vue-components disabled */import script from "./DramaListCard.vue?vue&type=script&setup=true&lang=js"
export * from "./DramaListCard.vue?vue&type=script&setup=true&lang=js"

import "./DramaListCard.vue?vue&type=style&index=0&id=4d039c5a&scoped=true&lang=less"

import exportComponent from "/Users/zhangxuan/Documents/Projects/VinesDjango/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d039c5a"]])

export default __exports__